import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy, inject, DestroyRef,
} from '@angular/core';
import {Router} from '@angular/router';
import {SettingsService} from 'src/app/app-shared/services/settings.service';
import {Subject} from 'rxjs';
import {CartService} from 'src/app/app-shared/services/cart.service';
import {SupplierOutletService} from '../../app-shared/services/supplier-outlet.service';
import {CartGroup} from '../../cart/models/cart.model';
import {BonusGroup, OrderByIdProducts, OrderTotalByOutlet} from "../../order-history/order-shared/models/order.model";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {takeUntil} from "rxjs";
import {UserPayers, UserSuppliersAndOutlets} from "../../app-shared/models/supplier-outlet.model";
import {StorageService} from "../../app-shared/services/storage.service";
import {PriorityListType, TransformedProductModel} from "../../catalog/models/product.model";
import {ProductsService} from "../../catalog/products/products.service";
import {ObjectForeSearch} from "../../catalog/models/search.model";
import {CatalogService} from "../../catalog/catalog.service";
import {SortByBooleanPipe} from "../../app-shared/pipes/sort-by-boolean/sort-by-boolean.pipe";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-cart-widget-preview',
    templateUrl: './cart-widget-preview.component.html',
    styleUrls: ['./cart-widget-preview.component.scss'],
    standalone: false
})
export class CartWidgetPreviewComponent implements OnInit {

  formOutlets: UntypedFormGroup;

  selectedGroup: CartGroup;
  selectedOutletId: number;
  selectedSupplierId: number;
  mobile: boolean;
  bonusGroups: BonusGroup[] = [];

  preCalculatedTotal: OrderTotalByOutlet;
  isUsePromo: boolean;
  payers: Array<UserPayers>;
  catalogProducts: TransformedProductModel[] = [];
  readonly priorityListType = PriorityListType;
  @Output() changed = new EventEmitter();
  isNeedReloadBonusProduct: boolean = true;
  isCartProductsInitialised: boolean = false;
  userSuppliersAndOutlets: Array<UserSuppliersAndOutlets>;
  isCartEmpty = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    public settings: SettingsService,
    public cartService: CartService,
    private supplierOutletService: SupplierOutletService,
    private storageService: StorageService,
    private productsService: ProductsService,
    private catalogService: CatalogService
  ) {
  }

  ngOnInit() {
    this.mobile = this.settings.isMobileSize();
    this.selectedOutletId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().outletId;
    this.selectedSupplierId = this.supplierOutletService.getUserSelectedSupplierAndOutlet().supplierId;
    this.isUsePromo = this.supplierOutletService.getSupplierByOutletIdAndSupplierId(
      this.selectedSupplierId, this.selectedOutletId).isUsePromo;
    this.setDefaultBonusProducts();
    this.loadOutlets();
    this.initData();
    this.checkReloadProductsInCart();
  }

  checkReloadProductsInCart() {
    this.cartService.productsInCartIsReload
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (isNeedReload) => {
          this.isNeedReloadBonusProduct = isNeedReload;
          this.loadOutlets();
          this.initData();
        }
      })
  }

  setDefaultBonusProducts() {
    this.cartService.productsInCartNew.forEach(group => {
      this.initBonusProducts(group);
    })
    this.isCartProductsInitialised = true;
  }

  private initData() {
    const group = this.cartService.productsInCartNew
      .filter(group => group.supplierId === this.selectedSupplierId && group.outletId === this.selectedOutletId)[0];
    if (!!group) {
      this.isCartEmpty = false;
      this.selectedGroup = group;
      this.bonusGroups = this.selectedGroup.bonusGroups;
      this.selectedOutletId = this.selectedGroup.outletId;
      this.selectedSupplierId = this.selectedGroup.supplierId;
      this.isUsePromo = this.supplierOutletService.getSupplierByOutletIdAndSupplierId(
        this.selectedSupplierId, this.selectedOutletId).isUsePromo;
      this.preCalculatedTotal = this.selectedGroup.preCalculatedTotal;
      this.loadProductsForCatalog();
      this.initBonusProducts(this.selectedGroup);
    } else {
      this.initEmptyCart();
    }
    this.buildFormOutlets();
    this.setPayerValue();
  }

  private initBonusProducts(group: CartGroup) {
    let savedBonus = JSON.parse(
      this.storageService.getFromLocalStorage('selectedBonusProduct'));
    const compositeKey = group?.id;
    let productsForAdd: OrderByIdProducts[] = [];
    const defaultSavedBonus = savedBonus;

    // delete from local storage bonus group if bonusProducts is empty for composite key and products was reload
    if (!group?.bonusGroups?.length && savedBonus && savedBonus[compositeKey] &&
      this.isCartProductsInitialised && this.isNeedReloadBonusProduct) {
      console.log('delete bonus')
      delete savedBonus[compositeKey];
    }

    if (group?.bonusGroups?.length) {
      const transformedBonusGroups = this.productsService.transformBonusGroupsToObj(group.bonusGroups);
      // clear previous selected bonus group by promo id
      if (savedBonus && savedBonus[compositeKey]) {
        Object.keys(savedBonus[compositeKey]).forEach(key => {
          if (!transformedBonusGroups[key]) {
            delete savedBonus[compositeKey][key];
          }
        })
      }
      for (let key in transformedBonusGroups) {
        if (!!(savedBonus && savedBonus[compositeKey] && savedBonus[compositeKey][key]?.length)) {
          // тут ми порівнюємо виконання промо і кількості вибраних промо груп і видозмінюємо  за потреби збережені бонуси
          const promoApplyCount = transformedBonusGroups[key][0]?.promoApplyCount;
          const savedPromoSelectedCount = savedBonus[compositeKey][key].reduce((acc, x) => acc + (x.selectedCount || 0), 0);
          // якщо к-ть виконань більша за збережену, то додаємо різницю групі з найменшим айді
          if(promoApplyCount > savedPromoSelectedCount) {
            const arr = savedBonus[compositeKey][key];
            const minIdx = arr.reduce(
              (minIndex, item, idx, arr) =>
                item.bonusGroupId < arr[minIndex].bonusGroupId ? idx : minIndex,
              0
            );
            savedBonus[compositeKey][key][minIdx].selectedCount += promoApplyCount - savedPromoSelectedCount;
          }
          // якщо к-ть виконань менша за збережену, то забираємо в останнього різницю
          if(promoApplyCount < savedPromoSelectedCount) {
            savedBonus[compositeKey][key] = this.productsService.normalizeSavedBonus(
              savedBonus[compositeKey][key],
              promoApplyCount
            );
          }
          // додаємо продукти згідно вибраних груп
          savedBonus[compositeKey][key].forEach((value: {bonusGroupId: number, selectedCount: number}) => {
              const item = transformedBonusGroups[key]
                .find((group: BonusGroup) => group.bonusGroupId === value['bonusGroupId']);
              if (!!(item && item.products)) {
                item.products.map(product => product.selectedBonusPromoId = key);
                productsForAdd = [...productsForAdd, ...item.products];
              }
            })
        } else {
          transformedBonusGroups[key][0].products.map(product => product.selectedBonusPromoId = key);
          productsForAdd = [...productsForAdd, ...transformedBonusGroups[key][0].products];
          savedBonus = this.productsService.addDefaultBonus(savedBonus, compositeKey, key, transformedBonusGroups[key][0])
        }
      }
    }
    this.storageService.addToLocalStorage('selectedBonusProduct', JSON.stringify(savedBonus));
    if (productsForAdd.length) {
      this.addBonusProducts(productsForAdd, group);
      if (JSON.stringify(defaultSavedBonus) !== JSON.stringify(savedBonus)) {
        this.productsService.reloadProductsInCart(group.outletId, group.supplierId, group.orderType, false);
      }
    }
  }


  addBonusProducts(products: OrderByIdProducts[], group: CartGroup) {
    const defaultBonusProducts: TransformedProductModel[] = []
    products.forEach((draftProduct) => {
      if (!group.products.some(product => product.productId === draftProduct.productId)) {
        const transformProduct =
          this.productsService.createNewTransformProductObjFromOrder(
            draftProduct
          );
        defaultBonusProducts.push(transformProduct);
      }
    });
    const mergedArr = [...defaultBonusProducts, ...group.products];
    this.cartService.addToCartGroupProducts(
      mergedArr,
      group.supplierId,
      group.outletId,
      group.orderType,
      false,
      group.canCreateOrder,
      group.userConfirmationRequired,
      group.creditLimit,
      group.suggestions,
      group.messages,
      group.bonusGroups);
    this.cartService.calcTotalAllCart(false);
    if (this.isNeedReloadBonusProduct) {
      this.productsService.reloadProductsInCart(this.selectedOutletId, this.selectedSupplierId, group.orderType, false);
    }
    //console.log('add bonus', this.cartService.productsInCartNew)
  }

  loadOutlets() {
    this.supplierOutletService.getUserSuppliersAndOutlets()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
      (userSuppliersAndOutlets) => {
        userSuppliersAndOutlets.forEach((so) => {
          so['isShowOptionIcon'] = this.cartService.productsInCartNew.some(group => group.outletId === so.outletId);
        });
        this.userSuppliersAndOutlets = userSuppliersAndOutlets;
      },
      () => {
        this.userSuppliersAndOutlets = [];
        this.formOutlets = this.fb.group({
          outletId: [],
          payerId: []
        });
      }
    );
  }

  private buildFormOutlets() {
    this.formOutlets = this.fb.group({
      outletId: [this.selectedOutletId],
      payerId: []
    });

    const outlet = this.formOutlets.get('outletId');
    outlet.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
      if (this.cartService.productsInCartNew.some(group => group.outletId === value)) {
        this.isCartEmpty = false;
        this.selectedGroup = this.cartService.productsInCartNew.filter(item => item.outletId === value)[0];
        this.bonusGroups = this.selectedGroup.bonusGroups;
        this.preCalculatedTotal = this.selectedGroup.preCalculatedTotal;
        this.selectedSupplierId = this.selectedGroup.supplierId;
        this.selectedOutletId = this.selectedGroup.outletId;
        this.isUsePromo = this.supplierOutletService.getSupplierByOutletIdAndSupplierId(
          this.selectedSupplierId, this.selectedOutletId).isUsePromo;
        this.loadProductsForCatalog();
        this.initBonusProducts(this.selectedGroup);
      } else {
        this.initEmptyCart();
        this.selectedOutletId = value;
      }
      this.setPayerValue();
    })
  }

  loadProductsForCatalog() {
    const idsCartProducts = this.selectedGroup.products.filter(el => !el.isBonus).map(product => product.productId);
    const idsCatalogProducts = this.catalogProducts.map(product => product.productId);
    const isNeedLoadCatalog = !idsCartProducts.every(id => idsCatalogProducts.includes(id));
    if (!isNeedLoadCatalog) {
      this.updateCartProducts();
      return;
    }
    const ids = this.selectedGroup.products.map(product => `${product.productId}`);
    if (ids.length) {
      this.catalogService.getProductsByInputParams({
        filterForPrice: [{plType: this.priorityListType.allLists,}],
        searchModel: {
          objectForeSearch: ObjectForeSearch.IsProductId,
          values: idsCartProducts,
        },
        srtType: '1',
        skip: 0,
        outletId: this.selectedOutletId,
        productWithFilter: [],
        breadCrumbs: [],
        supplierId: this.selectedSupplierId,
        take: 9999
      })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(catalog => {
          this.catalogProducts = [];
          catalog['products'].forEach(product => {
            this.catalogProducts.push(this.productsService.createNewTransformProductObjFromOrder(product));
          })
          this.updateCartProducts();
        });
    }
  }

  updateCartProducts() {
    this.catalogProducts.forEach(product => {
      if (product.promoActivity.length) {
        const mainProduct = this.selectedGroup.products.find(pr => pr.productId === product.productId);
        if (mainProduct) mainProduct.promoActivity = product.promoActivity;
      }
    })
  }

  setPayerValue() {
    this.payers = this.supplierOutletService.getUserPayersByOutletAndSupplierId(this.selectedOutletId);
    this.formOutlets.get('payerId').setValue(this.payers.length ? this.payers[0].payerId : null);
  }

  closeWidget() {
    this.changed.emit(false);
  }

  goToCartItem() {
    if (!(this.cartService.productsInCartNew.length > 0)) {
      return;
    }
    const group = !!this.selectedGroup ? this.selectedGroup : this.cartService.productsInCartNew[0];
    const selectedSupplierByOutlet =
      this.supplierOutletService.getSupplierByOutletIdAndSupplierIdSelectedModel(
        group.supplierId,
        group.outletId
      );

    this.router.navigate(['/cart/detail', group.supplierId, group.outletId, group.orderType])
      .then((navigated) => {
        if (navigated) {
          this.supplierOutletService.changeSelectedSupplierAndOutlet(selectedSupplierByOutlet);
          this.catalogService.changeSuppierAndOutlet.next(true);
        }
        this.changed.emit(false);
      });
  }

  trackByproductsInCartNew(index, item) {
    if (!item) {
      return null;
    }
    return item.productId;
  }

  clickEditBonus(event) {
    const selectedSupplierByOutlet =
      this.supplierOutletService.getSupplierByOutletIdAndSupplierIdSelectedModel(
        this.selectedGroup.supplierId,
        this.selectedGroup.outletId
      );
    this.supplierOutletService.changeSelectedSupplierAndOutlet(
      selectedSupplierByOutlet
    );
    sessionStorage.setItem('isNeedOpenBonusDialog', `${event}`);
    this.router.navigate(
    ['/cart/detail', this.selectedGroup.supplierId, this.selectedGroup.outletId, this.selectedGroup.orderType]);
    this.changed.emit(false);
  }

  initEmptyCart() {
    this.isCartEmpty = true;
    this.selectedGroup = null;
    this.bonusGroups = [];
    this.preCalculatedTotal = null;
  }
  productIsBonus(index: number) {
    const sortPipe = new SortByBooleanPipe();
    const sortedArray = sortPipe.transform(this.selectedGroup.products, true,  ['isLogistic', 'isBonus']);
    return sortedArray[index] && sortedArray[index].isBonus;
  }
}
